export const PATHS = {
  Home: '/',
  Login: '/login',
  Register: '/register',
  EmailVerification: '/verify/*',
  ForgotPassword: '/forgot-password',
  ResetPassword: '/reset-password',
  ExamResult: '/exam-result',
  Exam: {
    Index: '/exam',
    Root: '/exam/:examCardId',
    Instruction: '/exam/:examCardId/instruction',
    Completed: '/exam/:examCardId/completed',
    Break: '/exam/:examCardId/break',
    Processing: '/exam/:examCardId/processing',
    PrivacyNotice: '/exam/:examCardId/privacy-notice',
    TermsAndConditions: '/exam/:examCardId/terms-and-conditions',
    ProfileConfirmation: '/exam/:examCardId/profile-confirmation',
    Questionnaire: '/exam/:examCardId/questionnaire',
    Submitted: '/exam/:examCardId/submitted',
  },
  MyScore: {
    Root: '/my-score',
    Details: '/my-score/:examCardId',
  },
  Error: '/error',
  SessionExpired: '/session-expired',
  Terms: '/terms',
  Preview: {
    Index: '/preview',
    Root: '/preview/task/:taskId',
    Instruction: '/preview/task/:taskId/instruction',
    Completed: '/preview/task/:taskId/completed',
    Processing: '/preview/task/:taskId/processing',
    Submitted: '/preview/task/:taskId/submitted',
  },
};
